import { STRIPE_CONFIG } from '../config/stripeConfig';

export const PAYMENT_STORAGE_KEYS = {
  payload: 'pendingWebsitePayload',
  websiteId: 'pendingWebsiteId',
  userId: 'pendingWebsiteUserId',
  token: 'pendingPaymentToken',
  promoCode: 'pendingPromoCode',
};

const generateToken = () => {
  const array = new Uint32Array(4);
  crypto.getRandomValues(array);
  return Array.from(array, (n) => n.toString(36)).join('');
};

const redirectToUrl = (url) => {
  const token = generateToken();
  localStorage.setItem(PAYMENT_STORAGE_KEYS.token, token);

  const separator = url.includes('?') ? '&' : '?';
  window.location.href = `${url}${separator}utm_source=stripe&utm_campaign=${token}`;
};

export const redirectToPaymentLink = () => {
  redirectToUrl(STRIPE_CONFIG.paymentLinkUrl);
};

export const redirectToDiscountedPaymentLink = () => {
  redirectToUrl(STRIPE_CONFIG.discountedPaymentLinkUrl);
};

export const savePendingWebsite = ({
  userId,
  selectedTemplate,
  theme,
  websiteTitle,
  websiteDescription,
  sections,
  customCSS,
  customJS,
  uploadedImages,
  websiteId,
}) => {
  const payload = {
    userId: userId || '',
    title: websiteTitle || '',
    description: websiteDescription || '',
    template: selectedTemplate?.id || '',
    theme: theme?.id || '',
    sections: sections || [],
    customCSS: customCSS || '',
    customJS: customJS || '',
    images: uploadedImages || [],
    updatedAt: new Date().toISOString(),
  };

  localStorage.setItem(PAYMENT_STORAGE_KEYS.payload, JSON.stringify(payload));
  localStorage.setItem(PAYMENT_STORAGE_KEYS.userId, userId || '');

  if (websiteId) {
    localStorage.setItem(PAYMENT_STORAGE_KEYS.websiteId, websiteId);
  } else {
    localStorage.removeItem(PAYMENT_STORAGE_KEYS.websiteId);
  }
};

export const getPendingWebsite = () => {
  const payloadRaw = localStorage.getItem(PAYMENT_STORAGE_KEYS.payload);
  if (!payloadRaw) return null;

  return {
    payload: JSON.parse(payloadRaw),
    websiteId: localStorage.getItem(PAYMENT_STORAGE_KEYS.websiteId) || null,
    userId: localStorage.getItem(PAYMENT_STORAGE_KEYS.userId) || '',
  };
};

export const savePendingPromoCode = (codeId) => {
  localStorage.setItem(PAYMENT_STORAGE_KEYS.promoCode, codeId);
};

export const getPendingPromoCode = () => {
  return localStorage.getItem(PAYMENT_STORAGE_KEYS.promoCode);
};

export const clearPendingWebsite = () => {
  Object.values(PAYMENT_STORAGE_KEYS).forEach((key) => localStorage.removeItem(key));
};

export const getStoredToken = () => localStorage.getItem(PAYMENT_STORAGE_KEYS.token);

export const verifyPaymentToken = () => {
  const params = new URLSearchParams(window.location.search);
  const storedToken = localStorage.getItem(PAYMENT_STORAGE_KEYS.token);
  const source = params.get('utm_source');
  const campaign = params.get('utm_campaign');

  return source === 'stripe' && storedToken && campaign === storedToken;
};
